import { P2TextDescription, P2Accordion } from "react-bootstrap-common-script";
import { useCallback, useState } from "react";
import { HDBLinks } from "../../../utils/shared/links";

function StartApplicationAccordionInfo() {
  const [expandedAccordions, setExpandedAccordions] = useState<number[]>([]);

  const handleExpandedAccordion = useCallback((numbering:number)=>(e:boolean)=>{
    let updatedIndexes = [...expandedAccordions];
    if (e) {
      updatedIndexes.push(numbering);
    } else {
      updatedIndexes = updatedIndexes.filter((item) => item !== numbering);
    }
    setExpandedAccordions(updatedIndexes);
  },[expandedAccordions]);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <P2Accordion
        onToggle={handleExpandedAccordion(0)}
        defaultOpen={false}
        title={
          <P2TextDescription
            size="18px"
            color={expandedAccordions.includes(0) ? "#333333" : "#0C8188"}
            title={"Information for proposed owners"}
          />
        }
      >
        <div className="polymer-start-application__accordion_content">
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Applying for another subsidised flat"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            If the flat is within the 5-year Minimum Occupation Period (MOP),
            proposed owner(s) must fulfil the balance MOP before applying for
            another flat directly from HDB (including DBSS flats and Executive
            Condominium units). <a className="polymer-text-links" href={HDBLinks.information_for_proposed_owners.applying_subsidised_flat} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Obtaining a HDB loan for change in flat ownership"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            If an HDB concessionary loan is granted for the ownership change,
            proposed owner(s) will be treated as having enjoyed 1 HDB
            concessionary rate loan. For resale flat, the use of the CPF savings
            to service the mortgage loan is subject to CPF Board's rule on the
            valuation limit. <a className="polymer-text-links" href={HDBLinks.information_for_proposed_owners.obtaining_hdb_loan} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Obtaining a bank loan for change in flat ownership"}
          />
          <p style={{ margin: 0 }} className="polymer-start-application__accordion_content_paragraph">
            Proposed owner(s) who are obtaining a bank loan for the change in
            flat ownership may take note of the following:-
          </p>
          <ol style={{ marginBottom: "1.5rem" }} className="polymer-start-application__accordion_content_paragraph">
            <li>
              Seek clarification with the banks on their requirements pertaining
              to the change in flat ownership (i.e. if it can be done without
              monetary consideration)
            </li>
            <li>
              The bank loan cannot be refinanced with an HDB loan subsequently.
            </li>
            <li>
              The use of CPF monies to service the mortgage loan for resale
              flats is subject to CPF Board's rule on the withdrawal limit. <a className="polymer-text-links" href={HDBLinks.information_for_proposed_owners.obtaining_bank_loan} rel="noopener noreferrer" target="_blank">Read more</a>
            </li> 
          </ol>

          <P2TextDescription
            size="18px"
            color="#575757"
            title={
              "Subsequent acquisition of private property by Singapore Permanent Residents (SPR) household"
            }
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            Where all the proposed owners are Singapore Permanent Residents,
            they would need to dispose of the HDB flat within 6 months if they
            or their essential family members acquire a private property
            subsequently. <a className="polymer-text-links" href={HDBLinks.information_for_proposed_owners.spr_household} rel="noopener noreferrer" target="_blank">Read more</a>
          </p> 
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Stamp duty payable by proposed owner(s)"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            Proposed owner(s) may need to pay the respective stamp duties for
            the change in flat ownership, and upon a subsequent sale of the
            flat. <a className="polymer-text-links" href={HDBLinks.information_for_proposed_owners.stamp_duty} rel="noopener noreferrer" target="_blank">Read more</a>
          </p> 
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Minimum Occupation Period (MOP)"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            All proposed owners and essential occupiers* must physically live in the flat upon the change of ownership, and fulfil a Minimum Occupation Period (MOP) of 5 years. During this time, the flat cannot be sold or rented out, and the owners and essential occupiers cannot acquire an interest in private residential property. These actions are only permitted after the MOP ends and if all eligibility conditions are met. Failing to occupy the flat is an infringement of the conditions, HDB may take action to compulsorily acquire the flat in such cases.
          </p>
          <p className="mb-0 polymer-start-application__accordion_content_paragraph" style={{fontSize: 14, fontWeight: "500"}}>*An essential occupier refers to the parties necessary for the flat applicants to form a family nucleus, to meet the eligibility criteria for owning an HDB flat.</p>
        </div>
      </P2Accordion>
      <P2Accordion
        onToggle={handleExpandedAccordion(1)}
        defaultOpen={false}
        title={
          <P2TextDescription
            size="18px"
            color={expandedAccordions.includes(1) ? "#333333" : "#0C8188"}
            title={"Information for outgoing owners"}
          />
        }
      >
        <div className="polymer-start-application__accordion_content">
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"CPF refund to outgoing owner"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            The CPF monies used by the outgoing owner needs to be refunded to their CPF account with interest as required by the CPF Board. <a className="polymer-text-links" href={HDBLinks.information_for_current_owners.cpf_refund} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Buying an HDB flat with a second HDB loan"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            If the outgoing owner has obtained or is obtaining their second HDB
            mortgage loan to buy another flat, they needs to use their CPF
            refund and cash consideration to reduce the loan quantum for the
            second mortgage loan. <a className="polymer-text-links" href={HDBLinks.information_for_current_owners.cpf_refund} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={
              "Buying another subsidised flat upon change in flat ownership"
            }
          />
          <p className="mb-0 polymer-start-application__accordion_content_paragraph">
            Owners withdrawing their ownership from their first subsidised flat
            may apply to buy a second subsidised flat only after 5 years from
            the date of purchase of their first flat (if eligible). They may
            need to pay a resale levy when they buy their second subsidised
            flat. <a className="polymer-text-links" href={HDBLinks.information_for_current_owners.buy_another_flat} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <p className="mb-4 polymer-start-application__accordion_content_paragraph" style={{fontSize: 14, fontWeight: "500"}}>*Generally, change in flat ownership is without monetary consideration. The exception is where there is a Court Order directing so (if any).</p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Enjoyment of housing subsidy upon change in flat ownership"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            Existing owners who have enjoyed the housing subsidy for their
            subsidised flat (upon change in flat ownership), may need to pay a
            resale levy in cash, when they acquire another subsidised flat/
            Executive Condominium unit sold by the developer. <a className="polymer-text-links" href={HDBLinks.information_for_current_owners.enjoy_subsidy} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Owner status upon change in flat ownership"}
          />
          <p className="mb-4 polymer-start-application__accordion_content_paragraph">
            Upon completion of the transaction (i.e. after the legal document
            has been signed and payment made), the outgoing owner will no longer
            have any interest on the ownership of the flat.
          </p>
          <P2TextDescription
            size="18px"
            color="#575757"
            title={"Stamp duty payable by outgoing owner"}
          />
          <p className="mb-0 polymer-start-application__accordion_content_paragraph">
            The outgoing owner may need to pay Seller's Stamp Duty (SSD) for the
            change in flat ownership. <a className="polymer-text-links" href={HDBLinks.information_for_current_owners.stamp_duty} rel="noopener noreferrer" target="_blank">Read more</a>
          </p>
        </div>
      </P2Accordion>
      <P2Accordion
        onToggle={handleExpandedAccordion(2)}
        defaultOpen={false}
        title={
          <P2TextDescription
            size="18px"
            color={expandedAccordions.includes(2) ? "#333333" : "#0C8188"}
            title={"Other information"}
          />
        }
      >
        <div className="polymer-start-application__accordion_content">
          <ol className="mb-0 polymer-start-application__accordion_content_paragraph">
            <li className="mb-4">
              The applicant may save the application as draft and retrieve it
              within the next 28 days. Thereafter, the draft application will be
              deleted.
            </li>
            <li className="mb-4">
              Once the application is deleted or rejected, applicants will need
              to submit a fresh application if they wish to apply for a change
              in flat ownership in the future.
            </li>
            <li className="mb-4">
              HDB may contact the owner(s) to obtain more information or
              documents if they are needed to process the application.
            </li>
            <li className="mb-4">
              As this is a conveyancing transaction, the current/proposed
              owners may need to engage their private lawyers to handle the
              conveyancing matters if they are assessed to be eligible to
              proceed with the change in flat ownership.
            </li>
            <li className="mb-4">
              All the current and proposed flat owners need to personally attend
              an appointment at the managing HDB Branch to complete the change
              in flat ownership. HDB will inform the owner(s) subsequently on
              the scheduled appointment date and amount of fees payable.
              Examples of the fees payable include the relevant administrative
              fee, valuation fee, conveyancing fee, <a className="polymer-text-links" href={HDBLinks.other_information.stamp_fee} rel="noopener noreferrer" target="_blank">stamp fee</a> (e.g. Buyer's
              Stamp Duty, Additional Buyer's Stamp Duty, Seller's Stamp Duty),
              registration fee, etc.
            </li>
            <li className="mb-4">
              The online application may be cancelled if the additional
              information or documents are not submitted. In the event that the
              transaction is cancelled or subsequently aborted, all the current
              and proposed owners will need to make payment of the
              administrative fee and half of the conveyancing fee to HDB.
            </li>
            <li>
              As this is a conveyancing transaction, and HDB is appointed to act
              for the owners in the application. please note that it is
              subjected to HDB's discretion and further conditions that may be
              required to be submitted for processing. A medical memo may be
              required to be submitted for HDB's consideration. In order to not
              potentially delay the processing time, applicants are encouraged
              to obtain a <a className="polymer-text-links" target="_blank" href={`${process.env.PUBLIC_URL}/documents/Health Reason Medical Memo Sample.pdf`}>medical memo</a> for current owners certified by a medical
              professional that they are capable of dealing with high-value
              transactions with HDB.
            </li>
          </ol>
        </div>
      </P2Accordion>
    </div>
  );
}

export default StartApplicationAccordionInfo;
